import { ReactNode } from 'react';

export interface DividerProps {
  orientation?: 'horizontal' | 'vertical';
  label?: ReactNode;
  className?: string;
}

/**
 * Cienka linia separatora. Dla horizontal z label: linia + label w środku + linia.
 * Vertical nie wspiera label (nie ma sensu wizualnie).
 */
export function Divider({ orientation = 'horizontal', label, className }: DividerProps) {
  if (orientation === 'vertical') {
    return (
      <span
        role="separator"
        aria-orientation="vertical"
        className={['inline-block w-px self-stretch bg-border', className].filter(Boolean).join(' ')}
      />
    );
  }

  if (label) {
    return (
      <div
        role="separator"
        className={['flex items-center gap-3', className].filter(Boolean).join(' ')}
      >
        <span className="flex-1 h-px bg-border" />
        <span className="text-xxs uppercase tracking-wider text-text-muted font-medium shrink-0">
          {label}
        </span>
        <span className="flex-1 h-px bg-border" />
      </div>
    );
  }

  return (
    <hr
      className={['border-0 h-px bg-border', className].filter(Boolean).join(' ')}
    />
  );
}
